//Keeping this file at the moment to so that we can use it for dropdown menu
/**
 * @fileOverview File with Portal Header Links component
 * @description File containing PortalHeaderLinks function
 * @author Komal Chevli
 * @since 1.0.0
 */

import React from "react";
import { Link } from "react-router-dom";
import { accountTypesConstants } from '../../constants';
import * as token from '../../helpers/token';
import { gisRoutes } from '../../routes/routes'
import * as HeaderLinks from '../../constants/headerlinks.constants';
import { categoryGroupBy, permissionFinder } from '../../helpers/util';
//phrasebook
import phrasebookLoad from "../../i18n";
const phrasebook = phrasebookLoad()

const logged = () => {
  if (token.loggedAccountType()) {
    return <>
      <li><Link to={gisRoutes.visitor.profile}>{phrasebook.profile.profile}</Link></li>
      <li><Link to="/account/logout">{phrasebook.login_view.logout}</Link></li>
    </>
  } else {
    return <><li><Link to={gisRoutes.account.login}>{phrasebook.login_view.login_already}</Link></li>
      <li><Link to={gisRoutes.account.register}>{phrasebook.login_view.register_new}</Link></li></>
  }
}

const VisitorHeaderLinks = props => <div className="nav-bar">
  <button className="btn btn-nav-toggle"></button>
  <h1 className="logo">
    <a href="https://www.pccwglobal.com/" target="_blank">
      <img src="https://skyframework.pccwglobal.com/img/pccwglobal.svg" />
    </a>
  </h1>
  <h1 className="logo">
    <Link to={gisRoutes.visitor.dashboard}><img src={props.image} alt="" /></Link>
  </h1>

  <div className="mobile-nav">
    <ul className="nav nav-left">
      <li><Link to={gisRoutes.visitor.service_number_coverage}>Service Coverage</Link></li>
    </ul>
    <ul className="nav nav-left">
      <li><Link to={gisRoutes.visitor.contacts}>Contacts</Link></li>
    </ul>
    <ul className="nav nav-right nav-icons" key="">
      <li className="dropdown">
        <a href="#" className="btn-dropdown-toggle" data-toggle="dropdown">
          <span>My account</span>
          <i className="sky-icon-account_circle"></i></a>
        <ul className="dropdown-menu">
          {/* {/* <IconList routes={props.routes} /> */}
          {logged()}
        </ul>
      </li>
    </ul>
  </div>
</div>

const IconList = props => props.routes.filter(link => link.type === 'icon')
  .map(icon => <li><Link to={icon.path}>{icon.name}</Link></li>)


export default VisitorHeaderLinks
